import React, { Component } from "react";
import { base64FileDownload } from "../../utils/FileDownloadUtil";
import { withTranslation } from "react-i18next";
import NscBusinessSettings from "./NscBusinessSettings";
import DealerBusinessSettings from "./DealerBusinessSettings";
import MarketBusinessSettings from "./MarketBusinessSettings";
import TermsAndConditionsClient from "../../shared/clients/TermsAndConditionsClient";
import PendingActionClient from "../../shared/clients/PendingActionClient";
import {
  BUS_SETTINGS_TYPES,
  CUPID_ID,
  DELIVERY_BANDS,
  LEAD_TIMES,
  PAYMENT_THRESHOLD,
  TERMS_AND_CONDITIONS,
} from "../../common/Constants";

class BusinessSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDealerAcceptingTerms: false,
      acceptTermsAndConditions: {},
      isDataLoaded: false,
      termsAndConditionsHistory: [],
      enableUpload: undefined,
      restrictDropdown: false,
    };
    this.selectedTab = 0; // Standardized: NLD now starts on same tab as other markets
    this.filteredDealers = [];
    this.fromPending = false;

    this.pendingAction =
      this.props.location.query && this.props.location.query.fromPendingActions;
    this.businessSettingsVersion = this.getBusinessSettings();
  }

  componentDidMount() {
    if (this.props.isNsc) {
      if (
        this.pendingAction &&
        this.props.location.actionName === DELIVERY_BANDS
      ) {
        this.selectedTab = 1;
      } else if (
        this.pendingAction &&
        this.props.location.actionName === LEAD_TIMES
      ) {
        this.selectedTab = 3;
      } else if (
        this.pendingAction &&
        this.props.location.actionName === CUPID_ID
      ) {
        this.selectedTab = 2;
      } else if (
        this.pendingAction &&
        this.props.location.actionName === PAYMENT_THRESHOLD
      ) {
        this.selectedTab = 4;
      }
    }
    if (
      this.pendingAction &&
      this.props.location.actionName === TERMS_AND_CONDITIONS &&
      this.props.user.businessSettingsPage === -1
    ) {
      this.props.user.updateBusinessSettingsTab(0);
      this.fromPending = true;
    }
    this.filteredDealers = this.filterDealers();

    this.setState({ isDataLoaded: true });
  }

  handleTermsAndConditionsDownload = (termsAndConditions) => {
    base64FileDownload(
      termsAndConditions.file,
      "application/pdf",
      `${
        this.props.selectedMarket.toUpperCase() +
        " " +
        this.props.t("TermsandConditionsHistory.documentName") +
        termsAndConditions.version
      }.pdf`
    );
  };

  getBusinessSettings() {
    if (
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "dealerBusinessSettings:view"
      ) &&
      !this.props.isNsc
    ) {
      return BUS_SETTINGS_TYPES.DEALER;
    }

    return this.props.user.permissions.rolePermissions.hasOwnProperty(
      "marketBusinessSettings:view"
    )
      ? BUS_SETTINGS_TYPES.MARKET
      : BUS_SETTINGS_TYPES.NSC;
  }

  resetFromPending = () => {
    this.fromPending = false;
    this.setState({
      isDealerAcceptingTerms: false,
      restrictDropdown: false,
    });
  };

  alterComponentView = (termsAndConditions) => {
    this.setState(
      {
        isDealerAcceptingTerms: !this.state.isDealerAcceptingTerms,
        acceptTermsAndConditions: termsAndConditions,
        restrictDropdown: !this.state.restrictDropdown,
      },
      () => {
        if (this.fromPending) {
          this.props.history.push("/dashboard");
        } else {
          this.loadTermsAndConditionsHistory();
        }
      }
    );
  };

  deleteTerms = (version) => {
    const termsList = this.state.termsAndConditionsHistory;
    this.props.hideOrShow(true);
    TermsAndConditionsClient.deleteTermsAndConditions(
      this.props.user,
      version,
      this.props.selectedMarket
    )
      .then(() => {
        this.addTermsAndConditionsPA(version);
        termsList.forEach((terms, index) => {
          if (terms.version === version) {
            termsList.splice(index, 1);
            this.setState({
              termsAndConditionsHistory: termsList,
              enableUpload: !(termsList.length > 1),
            });
          }
        });
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  addTermsAndConditionsPA = () => {
    this.props.hideOrShow(true);
    PendingActionClient.addPA(
      this.props.user,
      TERMS_AND_CONDITIONS,
      this.props.selectedMarket
    ).finally(() => {
      this.props.hideOrShow(false);
    });
  };

  loadTermsAndConditionsHistory = () => {
    this.props.hideOrShow(true);
    TermsAndConditionsClient.retrieveTermsAndConditionsHistory(
      this.props.user,
      this.props.selectedMarket
    )
      .then((data) => {
        this.setState({
          termsAndConditionsHistory: data,
          enableUpload: !(data.length > 1),
        });
      })
      .catch(() => {})
      .finally(() => {
        // If this is coming from the dashboard
        if (
          this.pendingAction &&
          this.props.location.actionName === "TERMS_CONDITIONS" &&
          !this.props.isNsc &&
          this.props.user.businessSettingsPage === 0 &&
          this.fromPending
        ) {
          let tnC = this.state.termsAndConditionsHistory
            .slice()
            .find((terms) => !terms.accepted);

          if (
            this.props.location &&
            this.props.location.query &&
            this.props.location.query.fromPendingActions
          ) {
            tnC = this.state.termsAndConditionsHistory
              .slice()
              .find(
                (terms) =>
                  terms.futureTermsConditions ===
                  this.props.location.query.isFutureTermsAndConditions
              );
            tnC["actionId"] = this.props.location.query.actionId;
          }

          this.setState({
            isDealerAcceptingTerms: true,
            restrictDropdown: true,
            acceptTermsAndConditions: tnC,
          });
        }
        this.setState({ isDataLoaded: true });
        this.props.hideOrShow(false);
      });
  };

  filterDealers() {
    const filteredDealers = [];
    if (this.props.dealerGroup) {
      const currentDealer = this.props.dealerGroup.filter(
        (dealer) => dealer.commonId === this.props.user.commonId
      )[0];
      if (
        this.props.user.showAll &&
        (currentDealer.dealerType === "HUB" ||
          "MDLR" === currentDealer.dealerType)
      ) {
        this.props.dealerGroup.forEach((dealer) => {
          filteredDealers.push(dealer);
        });
      } else {
        filteredDealers.push(currentDealer);
      }
    }
    return filteredDealers.filter(
      (dealer) => dealer.isOnboarded && dealer.hasAccessControlContainsActive
    );
  }

  render() {
    if (this.state.isDataLoaded) {
      return (
        <div>
          {this.businessSettingsVersion === BUS_SETTINGS_TYPES.DEALER && (
            <DealerBusinessSettings
              {...this.props}
              startingTab={this.selectedTab}
              restrictDropdown={this.state.restrictDropdown}
              isDealerAcceptingTerms={this.state.isDealerAcceptingTerms}
              fromPending={this.fromPending}
              resetFromPending={this.resetFromPending}
              termsAndConditions={this.state.acceptTermsAndConditions}
              alterComponentView={this.alterComponentView}
              loadTermsAndConditionsHistory={this.loadTermsAndConditionsHistory}
              handleTermsAndConditionsDownload={
                this.handleTermsAndConditionsDownload
              }
              termsAndConditionsHistory={this.state.termsAndConditionsHistory}
              filteredDealers={this.filteredDealers}
              isDealer={true}
            />
          )}
          {this.businessSettingsVersion === BUS_SETTINGS_TYPES.NSC && (
            <NscBusinessSettings
              {...this.props}
              startingTab={this.selectedTab}
              restrictDropdown={this.state.restrictDropdown}
              handleTermsAndConditionsDownload={
                this.handleTermsAndConditionsDownload
              }
              isDealer={false}
              enableUpload={this.state.enableUpload}
              deleteTerms={this.deleteTerms}
              loadTermsAndConditionsHistory={this.loadTermsAndConditionsHistory}
              termsAndConditionsHistory={this.state.termsAndConditionsHistory}
            />
          )}
          {this.businessSettingsVersion === BUS_SETTINGS_TYPES.MARKET && (
            <MarketBusinessSettings
              {...this.props}
              startingTab={this.selectedTab}
              restrictDropdown={this.state.restrictDropdown}
              handleTermsAndConditionsDownload={
                this.handleTermsAndConditionsDownload
              }
              isDealer={false}
              enableUpload={this.state.enableUpload}
              deleteTerms={this.deleteTerms}
              loadTermsAndConditionsHistory={this.loadTermsAndConditionsHistory}
              termsAndConditionsHistory={this.state.termsAndConditionsHistory}
              filteredDealers={this.filteredDealers}
            />
          )}
        </div>
      );
    }
    return null;
  }
}

export default withTranslation("emp")(BusinessSettings);
